<template>
  <div>
    <B2CItemCard
      @clickButton="addBtnAction()"
      @clickCard="goToProductDetails(product)"
      :id="product.idBase64"
      :title="product.title"
      type="P"
      :imageUrl="product.imgUrl"
      :subtitle="product.brandName"
      :price="productPrice"
      :showPrice="!isAdditionalProduct"
      :stockAmount="product.onlineStock"
      :campaignValue="
        campaign && campaign.benefitRule === 2 ? 0 : discountPrice
      "
      :redCampaignBadge="campaign ? campaign.benefitRule === 3 : false"
      :campaignText="campaignText"
      :isFavorite="isUserFavorite"
      :class="$user.onlineSluttKundeId?'':'fav-hidden'"
    ></B2CItemCard>
  </div>
</template>

<script>
import { WebshopProduct } from "@/services/models";
import B2CItemCard from "@fixit/v-b2c-item/src/B2CItemCard.vue";
import webshopMixins from "@/components/webshop/cart/webshop.mixins";

export default {
  mixins: [webshopMixins],
  components: {
    B2CItemCard,
  },
  computed: {
    isUserFavorite(){
      return this.$store.getters['favorites/getFavoriteProuct'](this.product.id) != null
    },
    productDiscount() {
      if (this.product.discounts.length) {
        let discount = this.product.discounts[0];
        return Math.round(
          ((discount.OriginalPrice - discount.DiscountPrice) /
            discount.OriginalPrice) *
            100
        );
      }
      return Math.round(
        ((this.product.productDetails.price - this.product.salePrice) /
          this.product.productDetails.price) *
          100
      );
    },
    discountPrice() {
      if (this.product.discounts.length) {
        return Math.min(this.product.discounts.map((x) => x.DiscountPrice));
      } else return undefined;
    },
    productPrice() {
      if (this.product.discounts.length) {
        return this.product.discounts[0].OriginalPrice;
      } else {
        return this.product.salePrice === 0
          ? this.product.productDetails.price
          : this.product.salePrice;
      }
    },
    campaignText() {
      if (this.campaign) {
        if (this.isAdditionalProduct) {
          return 'Gave'
        }
        if (this.campaign.promotionType === 1) {
          //BUNDLE
          return "";
        } else if (this.campaign.promotionType.promotionType === 3) {
          return "Nyhet";
        } else if (this.campaign.promotionType.promotionType === 2) {
          return "Salg";
        } else if (this.campaign.benefitRule == 3) {
          return `Kjøp ${ this.campaign.benefitQty } få 1`
        } else {
          switch (this.campaign.benefitRule) {
            case 0:
              return this.product.promotionType.promotionType !== 1
                ? this.campaign.additionalValue + "%"
                : "";
            case 1:
              return (
                this.campaign.benefitQty + " for " + this.campaign.benefitValue1
              );
            case 2:
              return (
                this.campaign.benefitQty + " for " + this.campaign.benefitValue1
              );
            default:
              return "";
          }
        }
      } else if (this.product.bestCampaign) {
        if (this.product.bestCampaign.PromotionType === 1) {
          //BUNDLE
          return "";
        } else if (this.product.bestCampaign.PromotionType === 3) {
          return "Nyhet";
        } else if (this.product.bestCampaign.PromotionType === 2) {
          return "Salg";
        } else {
          switch (this.product.bestCampaign.BenefitRule) {
            case 0:
              return this.product.PromotionType !== 1
                ? this.product.bestCampaign.AdditionalValue + "%"
                : "";
            case 1:
              return (
                this.product.bestCampaign.BenefitQty +
                " for " +
                this.product.bestCampaign.BenefitValue1
              );
            case 2:
              return (
                this.product.bestCampaign.BenefitQty +
                " for " +
                this.product.bestCampaign.BenefitValue1
              );
            default:
              return "";
          }
        }
      } else {
        return "";
      }
    },
    outOfStock() {
      return (
        this.product.productDetails &&
        !this.product.productDetails.inventory.length
      );
    },

    cartProduct() {
      return this.$store.getters["clickAndCollect/get"]("items").find(
        (x) => x.id === this.product.id
      );
    },

    selectedProductId() {
      return (
        this.$store.getters["webshop/get"]("selectedProduct").id ||
        this.$route.params.productId
      );
    },
  },
  data() {
    return {
      windowSize: { x: window.innerWidth, y: window.innerHeight },
    };
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    bestPriceRuleCampaign() {
      return (
        this.product.productDetails.price == this.product.salePrice &&
        this.product.bestCampaign?.PromotionType == 4
      );
    },
    addBtnAction() {
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: this.product,
      });
      this.addProductToSalonCart(this.salons[0]);
    },

    openSalonSelectDialog() {
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: this.product,
      });
      this.$store.dispatch("webshop/set", {
        key: "salonPickOptions",
        value: { dialog: true },
      });
    },
  },
  props: {
    product: {
      type: WebshopProduct,
      default: null,
    },
    campaign: {
      type: Object,
      default: null,
    },
    isCampaignView: {
      type: Boolean,
      default: false,
    },
    isAdditionalProduct: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.action__buttons::v-deep {
  .v-btn {
    height: 42px !important;
  }
}

.free-product-text {
  width: 50%;
  font-weight: 500;
  font-size: 26px;
  line-height: 24px;
}

.product__description div {
  white-space: pre-wrap;
}

.v-skeleton-loader__heading {
  margin: 0 auto;
}

.product-discount-tag {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #ffffff;
  z-index: 1;
}
</style>
